<template>
	<div>
		<v-row>
			<v-col cols="12" md="3">
			</v-col>
			<v-col cols="12" md="6">
				<date-navigator v-model="dateRange">
					<div class="text-center">
						<v-btn color="primary" small dark class="mx-1" @click="loadData">
							دریافت اطلاعات
						</v-btn>
					</div>
				</date-navigator>
			</v-col>
			<v-col cols="12" md="3" class="d-flex align-center justify-end">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-data-table dense :headers="headers" :loading="loading" :items="items" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" class="elevation-1">
					<template v-slot:item.emailPanelText="{ item }">
						{{ translateEmailPanel(item.emailPanelText) }}
					</template>
					<template v-slot:item.date_Persian="{ item }">
						<div>{{ item.date_Persian.date }}</div>
						<div>{{ item.date_Persian.time }}</div>
					</template>
					<template v-slot:item.text="{ item }">
						<div @click="showEmailMessage(item.text)" style="max-width:250px;overflow:hidden;cursor:pointer;text-overflow: ellipsis;white-space: nowrap;">
							{{ item.text }}
						</div>
					</template>
					<template v-slot:item.appEmailTypeText="{ item }">
						{{ translateType(item) }}
					</template>
					<template v-slot:item.operations="{ item }">
						<v-btn small @click="resend(item)" :loading="rowLoading == item.id">
							ارسال مجدد
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="messageDialog" max-width="1000px">
			<v-card>
				<v-card-title>
					<div><span class="headline">متن ایمیل</span></div>
					<v-spacer />
					<v-btn @click="messageDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<p style="white-space: pre-wrap;" v-html="emailMessage"></p>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'EmailList',
		props: {
			email: { type: String },
			autoLoad: { type: Boolean, default: true },
			area: { type: String, default: '' }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'date-navigator': () => import('@/components/DateNavigator'),
		},
		data() {
			return {
				errorMessages: '',
				statusFilter: [],
				loading: false,
				rowLoading: '',
				headers: [
					{
						text: 'سرویس ایمیل',
						align: 'right',
						sortable: true,
						value: 'emailPanelText',
					},
					{
						text: 'زمان ارسال',
						align: 'center',
						sortable: true,
						value: 'date_Persian',
					}, {
						text: 'متن',
						align: 'right',
						sortable: true,
						value: 'text',
						width: 200
					}, {
						text: 'دریافت کننده',
						align: 'center',
						sortable: true,
						value: 'to',
					}, {
						text: 'نوع',
						align: 'center',
						sortable: true,
						value: 'appEmailTypeText',
					}, {
						text: 'عملیات',
						align: 'center',
						sortable: false,
						value: 'operations',
					}
				],
				items: [],
				messageDialog: false,
				emailMessage: '',
				dateRange: { start: new Date().toJSON(), end: '' },
				emailPanels: [
					{ id: 1, title: 'جت اقساط' },
					{ id: 2, title: 'سرویس شخصی' },
				],
			}
		},
		computed: {
			...get('siteConfig', [
				'isCloud'
			]),
			excelFileName() {
				let name = 'گزارش ایمیل ها'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		created() {
			if (this.area === 'superadmin') {
				this.headers.splice(0, 0, {
					text: 'مشتری',
					align: 'right',
					sortable: true,
					value: 'customer.name',
				})
			}
		},
		mounted() {
			if (this.autoLoad)
				this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get(`${this.area}/appemail/list/?start=` + this.dateRange.start + '&end=' + this.dateRange.end + '&email=' + (this.email ? this.email : ''), null)
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},

			translateType(item) {
				if (item.appEmailType == 0)
					return item.patternTitle

				let translates = {
					'Unknown': 'متفرقه',
					'DueDate': 'یادآوری سررسید',
					'Thanks': 'تشکر از پرداخت',
					'OverDueDate': 'معوق',
					'BeforeDueDate': 'یادآوری پیش از موعد',
					'ChangeStatus': 'تغییر وضعیت درخواست وام',
					'ChangeAgentStatus': 'تغییر وضعیت نماینده',
					'VerifyCode': 'کد تاییدیه',
					'Login': 'ورود به پنل',
					'Register': 'خوش آمد ثبت نام',
					'WalletCharge': 'شارژ کیف پول',
					'LoginOTP': 'رمز عبور پیامکی',
					'DailyReport': 'گزارش روزانه'
				}
				return translates[item.appEmailTypeText] || 'نامشخص'
			},
			translateEmailPanel(panel) {
				let items = {
					'Unknown': 'نامشخص',
					'JetAqsaat': 'جت اقساط',
					'Custom': 'سرویس شخصی',
				}
				return items[panel] || 'نامشخص'
			},
			showEmailMessage(text) {
				this.emailMessage = text
				this.messageDialog = true
			},
			async resend(item) {
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ارسال مجدد این ایمیل مطمئن هستید؟',
				)) {
					this.rowLoading = item.id
					api.post(`${this.area}/appemail/ReSend/` + item.id, null)
						.then(response => {
							toast.success('ایمیل ارسال شد.')
							this.loadData()
						})
						.catch(err => {
							toast.error(err.message)
						})
						.finally(() => {
							this.rowLoading = ''
						})
				}
			}
		},
	}
</script>
<style scoped>
	.email-row {
		justify-content: center;
		align-items: center;
		background-color: whitesmoke;
		border-radius: 10px;
		margin: 15px 0;
		padding: 10px 0;
		border: 1px solid #dca6e5;
	}
</style>